@if (!pageData) {
  <mat-spinner color="secondary"></mat-spinner>
}

<!-- content -->
@if (pageData) {
  <section>
    <div>
      <h1>
        {{ pageData.title }}
      </h1>
      @if (pageData && pageData.title !== 'Gallery') {
        <div class="callout">
          <h3>Have your own submissions?</h3>
          <div class="fx-layout-column--xs">
            <div class="fx-flex--100--xs">
              Enter your best submissions now.  You could win <strong>up to $300</strong>! Enter now for more information.
            </div>
            <div class="fx-flex--100--xs">
              <a mat-flat-button color="primary" routerLink="/matboard-awards">
                Enter Now
                <mat-icon svgIcon="chevron-right"></mat-icon>
              </a>
            </div>
          </div>
        </div>
      }
      @if (pageData.images && pageData.images.length > 0) {
        <mbnm-navigation-tiles [tileCollection]="pageData.images" mode="image" (tileClick)="  ($event)">
        </mbnm-navigation-tiles>
      }
      @for (galleryData of pageData.children; track galleryData) {
        @if (pageData.children.length > 1) {
          <h2>{{ galleryData.title }}</h2>
        }
        <mbnm-navigation-tiles [tileCollection]="galleryData.images" mode="image">
        </mbnm-navigation-tiles>
      }
    </div>
  </section>
}
